import React from 'react';
import './App.css';
import SuperStore from './DataStore/SuperStore';
import AppInitializer from './pages/AppInitializer';

function App() {
  return (<SuperStore>
            <AppInitializer />
          </SuperStore>
  );
}

export default App;
